module.exports = __webpack_public_path__ + "static/media/PbLogo.0a72365c.svg";